import { render, staticRenderFns } from "./Cart2.vue?vue&type=template&id=9caad7b6"
import script from "./Cart2.vue?vue&type=script&lang=js"
export * from "./Cart2.vue?vue&type=script&lang=js"
import style0 from "./Cart2.vue?vue&type=style&index=0&id=9caad7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports